// @flow
import { APICore } from './apiCore';

const api = new APICore();

// account
// function ApiGetAllKategoriFasilitas(params: any): any {
//     const baseUrl = '/api/admin/kategorimenu';
//     return api.get(`${baseUrl}`, params);
// }
function ApiGetAllGelang(params: any): any {
    const baseUrl = '/api/admin/gelang';
    return api.get(`${baseUrl}`, params);
}
// function ApiPostCategoryRoom(params: any): any {
//     const baseUrl = '/api/admin/kategoriroom';
//     return api.create(`${baseUrl}`, params);
// }
function ApiPostGelang(params: any): any {
    const baseUrl = '/api/admin/gelang';
    // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
    return api.create(`${baseUrl}`, params);
}
// function ApiEditKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.update(`${baseUrl}`, params);
// }
function ApiEditGelang(params: any, id: any): any {
    const baseUrl = '/api/admin/gelang/' + id;
    return api.update(`${baseUrl}`, params);
}
// function ApiDeleteKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.delete(`${baseUrl}`, params);
// }

export {
    // ApiGetAllKategoriMenu,
    ApiGetAllGelang,
    // ApiPostCategoryRoom,
    ApiPostGelang,
    // ApiEditKategoriRoom,
    ApiEditGelang,
    // ApiDeleteKategoriRoom,
};
